import { useEffect, useState } from 'react';
import { formatDate } from '../../../../lib/date';
import { WEIGHT_UNIT } from '../../../../types/enum';
import { convertWeight } from '../../../../lib/utils';
import { ReactComponent as CloseSvg } from '../../../../assets/svg/closeCircle.svg';
import { ReactComponent as LoadingSvg } from '../../../../assets/svg/loading-half-status.svg';
import TextInput from '../../../../components/textInput';
import DateInput from '../../../../components/dateInput';
import request from '../../../../lib/request';

const UpdateDialog = ({
  dialogRef,
  closeDialog,
  refresh,
  isDialogOpen,
  log,
  preference,
}) => {
  const [date, setDate] = useState(formatDate(new Date()));
  const [weight, setWeight] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isDialogOpen) {
      setDate(formatDate(new Date(log.logDate)));
      setWeight(log.weight);
    }
  }, [isDialogOpen]);

  const handleWeightChange = (e) => {
    setWeight(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let numWeight = Number(weight);
      if (!isNaN(numWeight) && numWeight > 0) {
        if (preference.weightUnit === WEIGHT_UNIT.LB) {
          numWeight = convertWeight(numWeight, WEIGHT_UNIT.LB, WEIGHT_UNIT.KG);
        }
        const { result } = await request.put(`/log/weight/${log.id}`, {
          weight: numWeight,
          date,
        });

        if (result) {
          await refresh();
          closeDialog();
          setWeight(0);
        }
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const handleCancel = () => {
    setWeight(0);
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={handleCancel}
    >
      <div className='bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl p-4 flex flex-col text-white overflow-y-hidden'>
        <div className='flex justify-end mb-6'>
          <button onClick={handleCancel}>
            <CloseSvg />
          </button>
        </div>
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Date</label>
          <input
            type='date'
            max={formatDate(new Date())}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className='rounded-full px-2 py-1 bg-tertiary  text-white'
          />
        </div>
        <div className='flex items-center justify-between mb-4'>
          <label className='text-white font-semibold'>Weight</label>
          <div className='text-white flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <input
                type='number'
                name='weight'
                value={weight}
                onChange={handleWeightChange}
                autoFocus={true}
                disabled={loading}
                className='rounded-full px-2 py-1 bg-tertiary text-white text-center max-w-20'
              />
              <span className='text-right min-w-10'>
                {preference.weightUnit === WEIGHT_UNIT.LB ? 'lb' : 'kg'}
              </span>
            </div>
          </div>
        </div>
        <div className=''>
          <button
            className='rounded-full w-full py-2 bg-accent font-bold text-black'
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <div className='flex justify-center items-center'>
                <LoadingSvg className='animate-spin' />
              </div>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default UpdateDialog;
